import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Globe, Shield } from 'lucide-react';
import { Button } from './Button';
export function AppHeader() {
  const navigate = useNavigate();
  return <header className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-md border-b border-slate-200" data-id="element-107">
      <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-108">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2" data-id="element-109">
          <Globe className="w-8 h-8 text-blue-600" data-id="element-110" />
          <span className="text-xl font-serif text-slate-900 tracking-tight" data-id="element-111">
            Affordable<span className="text-blue-600" data-id="element-112">Medical</span>Tourism
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-113">
          <Link to="/destinations" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-114">
            Destinations
          </Link>
          <Link to="/procedures" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-115">
            Procedures
          </Link>
          <Link to="/hospitals" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-116">
            Hospitals
          </Link>
          <Link to="/facilitators" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-117">
            Facilitators
          </Link>
          <Link to="/how-it-works" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-118">
            How It Works
          </Link>
          <Link to="/patient-guide" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-119">
            Patient Guide
          </Link>
          <Link to="/about" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-120">
            About
          </Link>
          <Link to="/faq" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-121">
            FAQ
          </Link>
        </nav>

        {/* Right Actions */}
        <div className="hidden lg:flex items-center gap-6" data-id="element-122">
          <div className="flex items-center gap-2 text-slate-500" data-id="element-123">
            <Shield className="w-4 h-4" data-id="element-124" />
            <span className="text-sm font-medium" data-id="element-125">HIPAA Aligned</span>
          </div>
          <Button onClick={() => navigate('/contact')} className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6" data-id="element-126">
            Get Free Consultation
          </Button>
        </div>

        {/* Mobile Menu Toggle (Simplified for prototype) */}
        <div className="lg:hidden" data-id="element-127">
          <Button variant="ghost" size="icon" onClick={() => navigate('/contact')} data-id="element-128">
            <Globe className="w-6 h-6" data-id="element-129" />
          </Button>
        </div>
      </div>
    </header>;
}